export default ['JsonRPCService', function (JsonRPCService) {
    return {
        getClaimSummaries: function getClaimSummaries(query, offset) {
            return JsonRPCService.send('cc', 'claim/claim', 'getClaimSummaries', [query, offset]);
        },

        getClaimDetail: function getClaimDetail(claimNumber) {
            return JsonRPCService.send('cc', 'claim/claim', 'getClaimDetail', [claimNumber]);
        },

        getClaimPolicyDetail: function getClaimPolicyDetail(claimNumber) {
            return JsonRPCService.send('cc', 'claim/claim', 'getClaimPolicyDetail', [claimNumber]);
        },

        getClaimActivities: function getClaimActivities(claimNumber) {
            return JsonRPCService.send('cc', 'claim/claim', 'getClaimActivities', [claimNumber]);
        },

        updateClaimNote: function updateClaimNote(claimId, note) {
            return JsonRPCService.send('cc', 'claim/claim', 'updateClaimNote', [claimId, note]);
        },

        deleteClaimNote: function deleteClaimNote(claimId, noteId) {
            return JsonRPCService.send('cc', 'claim/claim', 'deleteClaimNote', [claimId, noteId]);
        },

        createClaimNote: function createClaimNote(claimNumber, noteDTO) {
            return JsonRPCService.send('cc', 'claim/claim', 'createClaimNote', [claimNumber, noteDTO]);
        },

        getClaimNotes: function getClaimNotes(claimNumber) {
            return JsonRPCService.send('cc', 'claim/claim', 'getClaimNotes', [claimNumber]);
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/claim/services/ClaimService.js
// module id = 1431
// module chunks = 0